/**
 * Who has an appointment, as the emoji they picked in Settings → Team.
 * Ported from tperent's `StaffMark`.
 *
 * Renders nothing without a mark: an unassigned appointment, or one whose
 * member never picked, reads as "nobody yet" rather than borrowing a glyph the
 * team would have to learn. `role="img"` with the name, because the calendar
 * shows the mark with no name beside it and a bare emoji says nothing to a
 * screen reader.
 *
 * Which mark is whose is `markByAssignee` in `lib/appointments.ts`; the rule
 * for what counts as one is `@fitting-room/contracts/calendar-marks`.
 */
export function StaffMark({ mark, name }: { readonly mark: string | undefined; readonly name?: string | undefined }) {
  if (!mark) return null
  return (
    <span role="img" aria-label={name ? `Bridal stylist: ${name}` : 'Bridal stylist'} title={name} className="st-staff-mark">
      {mark}
    </span>
  )
}
